import { Box, CircularProgress } from '@mui/material'
import { Authenticated } from '@refinedev/core'
import { CatchAllNavigate } from '@refinedev/react-router-v6'
import { Suspense } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { routes as analyticsRoutes } from '@/features/analytics'
import { EmailLinkCompletePage, LoginPage } from '@/features/auth'
import { routes as osaSchedulingRoutes } from '@/features/osa-scheduling'
import { schedulingRoutes } from '@/features/scout-scheduling'
import { routes as scoutsRoutes } from '@/features/scouts'
import { ErrorBoundary, Title, CustomLayout } from '@/shared/components'

const LoadingFallback = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <CircularProgress />
  </Box>
)

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <Authenticated key="authenticated" fallback={<Navigate to="/login" />}>
            <CustomLayout Title={Title}>
              <ErrorBoundary>
                <Suspense fallback={<LoadingFallback />}>
                  <Outlet />
                </Suspense>
              </ErrorBoundary>
            </CustomLayout>
          </Authenticated>
        }
      >
        {scoutsRoutes}
        {osaSchedulingRoutes}
        {analyticsRoutes}
        <Route path="*" element={<CatchAllNavigate to="/scouts" />} />
      </Route>
      {schedulingRoutes}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/complete" element={<EmailLinkCompletePage />} />
    </Routes>
  )
}
